import React from 'react'

import { Checkbox } from 'ui/components/Checkbox'

export const CheckboxDefaultValue: React.FC<{
    value: FieldDto['default_value']
    onChange: (value: FieldDto['default_value']) => void
}> = ({ value, onChange }) => {
    return (
        <Checkbox
            checked={Boolean(value?.value) ?? false}
            onCheckedChange={(checked) => {
                onChange({ type: 'constant', value: checked })
            }}
        />
    )
}
